import { render, staticRenderFns } from "./ModattaStepOffer.vue?vue&type=template&id=258a28a6&scoped=true"
import script from "./ModattaStepOffer.vue?vue&type=script&lang=js"
export * from "./ModattaStepOffer.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepOffer.vue?vue&type=style&index=0&id=258a28a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a28a6",
  null
  
)

export default component.exports